import { sortBy, sum } from "lodash-es";
import uniq from "lodash-es/uniq";
import { IsToday } from "motw_core/Services/TimeServices";
import { Dictionary } from "motw_core/Utils/Dictionary";
import { IMappedData } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/StateProgressChart/IMappedData";
import { ArrayUtils } from "source/app/services/ArrayUtils";

export function GetDominanceDictionary(
    countsDictionary: Dictionary<string, IMappedData[]>
) {
    const allValues: Record<string, IMappedData[]> =
        countsDictionary.GetAllValues();

    var allDates = GetAllDates(allValues).filter(
        (dateString) => !IsToday(dateString)
    );

    var dominanceRecords = allDates.map((dateString) =>
        GetDominanceRecord(dateString, allValues)
    );

    var dataDictionary = GetDataDictionary(dominanceRecords);
    return dataDictionary;
}

function GetDataDictionary(dominanceRecords: IDominanceRecord[]) {
    // : Dictionary<string, IMappedData[]> {
    var initialMap: Record<string, IMappedData[]> = {};

    const emotionCharacters = Object.keys(dominanceRecords[0].dominanceForDate);

    // Initialize array for each emotion character
    emotionCharacters.forEach((emotionCharacter) => {
        initialMap[emotionCharacter] = [];
    });

    // Populate iMappedData array
    dominanceRecords.forEach((dominanceRecord) => {
        emotionCharacters.forEach((emotionCharacter) => {
            var mappedData = {
                time: dominanceRecord.dateString,
                value: dominanceRecord.dominanceForDate[emotionCharacter],
            } as IMappedData;

            initialMap[emotionCharacter].push(mappedData);
        });
    });

    var dataDictionary: Dictionary<string, IMappedData[]> = new Dictionary(
        initialMap
    );

    return dataDictionary;
}

function GetAllDates(allValues: Record<string, IMappedData[]>) {
    let allDates: string[] = [];

    for (const emotionCharacter in allValues) {
        const keyValues = allValues[emotionCharacter];

        const datesForEmotionCharacter = keyValues.map(
            (mappedDataRow) => mappedDataRow.time
        );

        allDates = ArrayUtils.AddRangeToWithoutRepeating(
            allDates,
            datesForEmotionCharacter
        );
    }

    const uniqueDates = uniq(allDates);
    const sortedDates = sortBy(uniqueDates, (dateString) => dateString);
    return sortedDates;
}

function GetDominanceRecord(
    dateString: string,
    allValues: Record<string, IMappedData[]>
): IDominanceRecord {
    const dominanceRecord: IDominanceRecord = {
        dateString,
        countsForDate: {},
        totalCount: 0,
        dominanceForDate: {},
    };

    CalculateCounts(allValues, dateString, dominanceRecord);
    CalculateDominance(allValues, dominanceRecord);
    return dominanceRecord;
}

interface IDominanceRecord {
    dateString: string;
    countsForDate: Record<string, number>;
    totalCount: number;
    dominanceForDate: Record<string, number>;
}

function CalculateDominance(
    allValues: Record<string, IMappedData[]>,
    dominanceRecord: IDominanceRecord
) {
    for (const emotionCharacter in allValues) {
        const dominance =
            dominanceRecord.totalCount === 0
                ? 0
                : dominanceRecord.countsForDate[emotionCharacter] /
                  dominanceRecord.totalCount;

        const roundedDominance = Math.floor(dominance * 100);
        dominanceRecord.dominanceForDate[emotionCharacter] = roundedDominance;
    }
}

function CalculateCounts(
    allValues: Record<string, IMappedData[]>,
    dateString: string,
    dominanceRecord: IDominanceRecord
) {
    for (const emotionCharacter in allValues) {
        const keyValues = allValues[emotionCharacter];

        const countValues = keyValues
            .filter((mappedDataRow) => mappedDataRow.time === dateString)
            .map((record) => record.value);

        if (countValues.length !== 1) {
            dominanceRecord.countsForDate[emotionCharacter] = 0;
        } else {
            dominanceRecord.countsForDate[emotionCharacter] = sum(countValues);

            dominanceRecord.totalCount +=
                dominanceRecord.countsForDate[emotionCharacter];
        }
    }
}
